import React from 'react';
import { ArrowRightIcon, RocketIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  showRocket?: boolean;
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick,
  showRocket = true
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    relative inline-flex items-center justify-center w-full
    px-5 py-4 sm:px-6 sm:py-5
    bg-gradient-to-r from-emerald-500 to-emerald-400
    text-white font-black text-base sm:text-lg uppercase tracking-wide
    rounded-2xl shadow-[0_0_25px_rgba(16,185,129,0.45)]
    hover:shadow-[0_0_35px_rgba(16,185,129,0.65)] hover:scale-[1.01]
    transition-all duration-300 group overflow-hidden border border-emerald-300/30
    ${className}
  `;
  const content = <span className="relative z-10 flex items-center text-center justify-center gap-2 leading-tight" data-id="element-75">
      {showRocket && <span className="text-xl" data-id="element-76">🚀</span>}
      <span data-id="element-77">{children}</span>
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} target={href.startsWith('http') ? '_self' : '_self'} data-id="element-78">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-79">
      {content}
    </button>;
}